import { render, staticRenderFns } from "./ContractPage.vue?vue&type=template&id=95622e70&scoped=true&"
import script from "./ContractPage.vue?vue&type=script&lang=js&"
export * from "./ContractPage.vue?vue&type=script&lang=js&"
import style0 from "./ContractPage.vue?vue&type=style&index=0&id=95622e70&prod&lang=sass&"
import style1 from "./ContractPage.vue?vue&type=style&index=1&id=95622e70&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95622e70",
  null
  
)

export default component.exports